import isEmpty from './isEmpty';
export function toTransformValue(value) {
    return Object.keys(value).reduce((values, key) => {
        const v = value[key];
        if (!isEmpty(v)) {
            values.push(`${key}(${v})`);
        }
        return values;
    }, []).join(' ');
}
export default function transform(value, style) {
    if (style) {
        style.transform = value;
        style.webkitTransform = value;
        return;
    }
    return ['-webkit-', '-ms-', ''].map(prefix => `${prefix}transform:${value}`).join(';');
}
